import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "../../store"
const LoginModule = {
    namespaced: true,
    state: {
        marking: false
    },
    mutations: {
        setMarking(state, val){
            state.marking = val
        }
    },
    actions: {
        onMarkNotice({commit}, body){
            //commit('setMarking', true)
            
            commit('setMarking', true)
            Service.onMarkNotice(body).then((res) => {
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                commit('setMarking', false)
            })
        },
        onUpdateImgProfile({commit}, body){
            Service.onUpdateProfileImage(body).then((response) => {

            }).catch((err) => {
                console.log(err)
            });
        },
        onUpdatePhoneNumber({commit}, body){
            Service.onUpdatePhoneProfile(body).then((response) => {

            }).catch((err) => {
                console.log(err)
            });
        },
        onUpdateDisplaynameProfile({commit}, body){
            Service.onUpdateDisplaynameProfile(body).then((response) => {

            }).catch((err) => {
                console.log(err)
            });
        },
        onUpdateProfile({commit}, body) {
            Service.onUpdateProfileInfomation(body)
                .then((response) => {
                    store.dispatch('auth/fetchUpdateUserData',response)
                    // location.reload()
                })
                .catch((err) => {
                    console.log(err)
                });
        }
    },
    getters: {
        getMarkging(state){
            return state.marking;
        }
    }
};

export default LoginModule;
